import { Box, Typography, IconButton } from "@mui/material";
import LockIcon from "@mui/icons-material/Lock";

const ModuleNotAccessible = () => {
  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      height="100vh"
      bgcolor="background.default"
      textAlign="center"
    >
      <IconButton
        size="large"
        color="error"
        sx={{ mb: 2 }}
        disableRipple
        disableFocusRipple
        id="snr-ai-ModuleNotAccessible-lockIconButton"
      >
        <LockIcon sx={{ fontSize: 50 }} />
      </IconButton>
      <Typography variant="h4" gutterBottom>
        Access Denied
      </Typography>
      <Typography variant="body1">
        You don’t have permission to view this module. Please contact your
        administrator if you believe this is a mistake.
      </Typography>
    </Box>
  );
};

export default ModuleNotAccessible;